import { useEffect } from 'react'
import { getJson } from '../api'
import { useAuth } from '../auth'
import { useLang } from '../i18n'

/**
 * Перенос языка между «до входа» и профилем.
 *
 * До входа выбор живёт в localStorage — экран входа рисуется раньше, чем профиль
 * вообще известен. После входа он должен стать частью профиля, иначе человек,
 * выбравший английский на телефоне, снова получит русский на судовом компьютере.
 *
 * Живёт отдельным компонентом внутри AuthGate, а не в LangProvider: провайдер
 * стоит НАД авторизацией (он нужен экрану входа) и про пользователя не знает.
 */
export function ProfileLangSync() {
  const { token } = useAuth()
  const { adoptProfileLang } = useLang()

  useEffect(() => {
    if (!token) return
    let cancelled = false
    getJson<{ lang: string | null }>('/api/v1/cabinet/profile/lang')
      .then(res => {
        if (!cancelled) adoptProfileLang(res.lang)
      })
      .catch(() => {
        /* профиль недоступен — остаёмся на языке домена/браузера */
      })
    return () => {
      cancelled = true
    }
  }, [token, adoptProfileLang])

  return null
}
